'use strict';

import GenericTableData from './GenericTableData';

let RequestDocumentData = GenericTableData.getTableDataBus(
  'REQ_DOC',
  'request_documents',
);

RequestDocumentData.deleteDocument = (docObject, requestId) => {
  return RequestDocumentData.deleteRecordsWhere({
    document_id: docObject.id,
    request_id: requestId,
  });
};
export default RequestDocumentData;
